<template>
    <v-chip
        class="live-position font-weight-bold"
        :class="[
            color,
            { 'label-left': left },
            text === 'Live' ? (domainUrl ? '' : 'super-live-position') : ''
        ]"
        :color="
            text === 'Live' ? (domainUrl ? 'white--text' : 'superBlue') : ''
        "
        dark
        x-small
        label
        v-bind="$attrs"
        v-on="$listeners"
    >
        {{ text }}
    </v-chip>
</template>
<script>
export default {
    props: {
        left: { type: Boolean, default: false },
        color: { type: String, default: "green" },
        text: { type: String, default: "Live" }
    },
    data() {
        return {
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0
        }
    }
}
</script>

<style lang="scss" scoped>
.live-position {
    position: absolute !important;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    &.label-left {
        top: -3px;
        left: 10px;
        transform: translate(0, -50%);
    }
}
.super-live-position {
    border: 1px solid var(--v-superBlue-base) !important;
    background: var(--v-superBlue-base) !important;
}
</style>
